import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import { useGoogleAnalytics, useGoogleMaps } from './_config/config'
import './plugins/axios'
import './plugins/fontawesome'
import './plugins/vue-meta'
import './plugins/vue-accept-decline'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { store } from './store'
import interceptorSetup from './_helpers/interceptor'
import { version } from './_config/version'
import reportError from './_helpers/error_reporting'
import { dom } from '@fortawesome/fontawesome-svg-core'

if (useGoogleAnalytics) {
  require('./plugins/vue-analytics')
}

if (useGoogleMaps) {
  require('./plugins/vue-maps')
}

// Axios Interceptor to refresh token
interceptorSetup()

dom.watch()

// Catch errors
if (Vue.config.devtools !== true) {
  Vue.config.errorHandler = function (err, vm, info) {
    const errDetails = {
      type: 'Vue',
      error: {
        message: err.message,
        lineNumber: err.lineNumber,
        fileName: err.fileName,
        columnNumber: err.columnNumber,
        stack: err.stack
      },
      info: info,
      version: version
    }

    reportError(errDetails)
  }
}

Vue.config.productionTip = false

require('./components/templates')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (Vue.config.devtools !== true) {
  window.addEventListener('unhandledrejection', function (event) {
    const errDetails = {
      type: 'Unhandled Rejection',
      error: {
        message: event.reason.message,
        lineNumber: event.reason.lineNumber,
        fileName: event.reason.fileName,
        columnNumber: event.reason.columnNumber,
        stack: event.reason.stack
      },
      version: version
    }

    event.preventDefault()
    reportError(errDetails)
  })
}
